// note this may come from a package at a later date
import { industryOptions } from './industry-categories-list.js';

function findIndustryById(id) {

    for (const category of industryOptions) {
        const industry = category.options.find(option => option.id === id);
        if (industry) {
            return { ...industry, category: category.category };
        }
    }

    return null;
}

window.addEventListener('DOMContentLoaded', () => {
    const data = {
        'event': 'user_info'
    };

    if (window.RotaCloudUserInfo) {
        const userInfo = window.RotaCloudUserInfo;
        const user = userInfo.user;
        const account = userInfo.account;

		if (user?.level !== undefined) {
            data['user_level'] = user.level;
        }

		if (account?.id !== undefined) {
            data['account_id'] = account.id;
        }

        if (account?.time_attendance !== undefined) {
            data['user_time_attendance'] = account.time_attendance;
        }

        if (account?.pro !== undefined) {
            data['user_pro'] = account.pro;
        }

        if (account?.industryId !== undefined) {

            const industry = findIndustryById(account.industryId);
            if (industry) {
				data['industry_id'] = industry.id;
				data['industry_category'] = industry.category;
				data['industry_name'] = industry.name;
            }
        }

		if (account?.accountStatus !== undefined) {
            data['account_status'] = account.accountStatus;
        }

		window.dataLayer = window.dataLayer || [];
    	window.dataLayer.push(data);
    }


});